import api from '../utils/api';

/**
 * Bug Report Service
 * Report-a-bug widget + admin bug report section
 */

export const bugService = {
  /**
   * Submit a bug report
   * @param {{ issue: string, newsUrl?: string, attachments?: Array, pageUrl?: string,
   *           frontendBuild?: number, frontendVersion?: string }} payload
   */
  reportBug: async (payload) => {
    return api.post('/bug-reports', payload);
  },

  /**
   * Get a signed URL to upload an attachment to GCS
   */
  getUploadSignedUrl: async (fileName, contentType, fileSize) => {
    return api.post('/bug-reports/upload-signed-url', {
      fileName,
      contentType,
      fileSize,
    });
  },

  /**
   * Get bug reports
   * Admin and super_admin get all reports, other users get their own
   */
  getBugReports: async (params = {}) => {
    return api.get('/bug-reports', { params });
  },

  /**
   * Get bug report counts by status (scoped the same way as the list)
   */
  getBugCounts: async () => {
    return api.get('/bug-reports/counts');
  },

  /**
   * Get a single bug report with its reply thread
   * Admins can open any report, other users only their own
   */
  getBugReport: async (bugId) => {
    return api.get(`/bug-reports/${bugId}`);
  },

  /**
   * Update a bug report status
   * Admins can set any status, the reporter can only mark their own resolved
   */
  updateBugStatus: async (bugId, status) => {
    return api.patch(`/bug-reports/${bugId}/status`, { status });
  },

  /**
   * Reply on a bug report thread (reporter or admin, until it is resolved/closed)
   * Attachments are uploaded to GCS first - this only carries their URLs
   * @param {string} bugId
   * @param {string} message
   * @param {Array<{url: string, fileName?: string, contentType?: string}>} attachments
   */
  addBugReply: async (bugId, message, attachments = []) => {
    return api.post(`/bug-reports/${bugId}/replies`, { message, attachments });
  },

  /**
   * Mark a bug report thread as read for the logged-in user
   * Clears the unread-replies badge for that thread
   */
  markBugRead: async (bugId) => {
    return api.post(`/bug-reports/${bugId}/read`);
  },

  /**
   * Delete a bug report (admin and super_admin only)
   */
  deleteBug: async (bugId) => {
    return api.delete(`/bug-reports/${bugId}`);
  },
};
